// Auto-detect API URL based on environment
const isLocalhost = window.location.hostname === 'localhost' || 
                    window.location.hostname === '127.0.0.1' ||
                    window.location.hostname === '';

// Use Node.js backend for localhost, PHP backend for production
const API_URL = process.env.REACT_APP_API_URL || 
                (isLocalhost 
                  ? 'http://localhost:5000/api' 
                  : '/backend-php/api');

// Simple fetch helper
const apiFetch = async (url, options = {}) => {
  const response = await fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  });
  
  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  
  return response.json();
};

// ============= CATEGORIES API =============

export const getCategories = async () => {
  const result = await apiFetch(`${API_URL}/categories`);
  return result.success ? result.data : [];
};

export const getCategory = async (id) => {
  const result = await apiFetch(`${API_URL}/categories/${id}`);
  return result.success ? result.data : null;
};

export const createCategory = async (categoryData) => {
  const response = await fetch(`${API_URL}/categories`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(categoryData)
  });
  if (!response.ok) throw new Error('Failed to create category');
  return response.json();
};

export const updateCategory = async (id, categoryData) => {
  const response = await fetch(`${API_URL}/categories/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(categoryData)
  });
  if (!response.ok) throw new Error('Failed to update category');
  return response.json();
};

export const deleteCategory = async (id) => {
  const response = await fetch(`${API_URL}/categories/${id}`, {
    method: 'DELETE'
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to delete category');
  }
  return response.json();
};

// ============= PRODUCTS API =============

export const getProducts = async () => {
  const result = await apiFetch(`${API_URL}/products`);
  return result.success ? result.data : [];
};

export const getProductsByCategory = async (categoryId) => {
  const result = await apiFetch(`${API_URL}/products/category/${categoryId}`);
  return result.success ? result.data : [];
};

export const getProduct = async (id) => {
  const result = await apiFetch(`${API_URL}/products/${id}`);
  return result.success ? result.data : null;
};

export const createProduct = async (productData) => {
  const response = await fetch(`${API_URL}/products`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(productData)
  });
  if (!response.ok) throw new Error('Failed to create product');
  return response.json();
};

export const updateProduct = async (id, productData) => {
  const response = await fetch(`${API_URL}/products/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(productData)
  });
  if (!response.ok) throw new Error('Failed to update product');
  return response.json();
};

export const deleteProduct = async (id) => {
  const response = await fetch(`${API_URL}/products/${id}`, {
    method: 'DELETE'
  });
  if (!response.ok) throw new Error('Failed to delete product');
  return response.json();
};

